























































































































































































































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import FileUploader from "@/components/FileUploader.vue";
import Page from "@/views/Page.vue";
import IFamily from "../../models/interfaces/IFamily";
import FamiliesMixin from "../../mixins/http/FamiliesMixin";
import { RegisterHttp } from "../../utils/Decorators";
import VCheckbox from "@/components/VCheckbox.vue";

import RequestData from "@/store/types/RequestData";
import { Family } from "../../models";
import { showToast } from "../../utils/RailsRoutes";
import { httpStore } from "@/store/typed";

@Component({ components: { Page, FileUploader, VCheckbox } })
export default class FamilyEdit extends Mixins(FamiliesMixin) {
  private family: Family = null;

  private newAttachments = [];

  static readonly updateFamilytag = "update_family_tag";
  @RegisterHttp(FamilyEdit.updateFamilytag) updateFamilyRequest: RequestData;

  static readonly getFamilytag = "get_family_tag";
  @RegisterHttp(FamilyEdit.getFamilytag) getFamilyRequest: RequestData;

  static readonly destroyFamiliesTag = "destroy_families_tag";
  @RegisterHttp(FamilyEdit.destroyFamiliesTag)
  destroyFamiliesRequest: RequestData;

  private icon = null;
  private newIcon = null;

  get url() {
    return this.newIcon?.url || this.icon?.url;
  }

  destroy() {
    this.destroyFamily(this.family.id, FamilyEdit.destroyFamiliesTag).then(
      (resp) => {
        showToast(`${this.family.name} deleted successfully`);
        this.$router.go(-2);
      },
      (err) => {
        showToast(`An error occurred while deleting ${this.family.name}`, {
          type: "error",
        });
      }
    );
  }

  get loading() {
    return this.updateFamilyRequest?.loading;
  }

  get valid() {
    return (
      this.family?.code &&
      this.family?.descriptionIt &&
      this.family?.descriptionEn &&
      this.family?.name
    );
  }

  isAttachmentDeletLoading(attachment) {
    return httpStore.status[this.detachFileTag(attachment)]?.loading;
  }

  get isAttachmentUploadLoading() {
    return httpStore.status[this.attachFilesTag]?.loading;
  }

  get attachFilesTag() {
    return "catalogue_family_files_attach";
  }

  detachFileTag(file) {
    return `detach_${file.id}_tag`;
  }

  detachAttachment(attachment) {
    const tag = this.detachFileTag(attachment);
    this.detachFile(
      { id: this.family.id, attachment_id: attachment.id },
      tag
    ).then((resp) => {
      const index = this.family.attachments.findIndex(
        (o) => o.id === attachment.id
      );

      this.family.attachments.splice(index, 1);
    });
  }

  onFileChange(attachments) {
    this.attachAttachment(attachments);
  }

  attachAttachment(attachments) {
    const data = new FormData();
    data.append("id", this.family.id);

    attachments.forEach((el: any) => {
      data.append("files[]", el.file);
    });

    this.attachFile(this.family.id, data, this.attachFilesTag).then(
      (family) => {
        this.family.attachments = family.attachments;
      }
    );
  }

  mounted() {
    this.loadFamily();
  }

  loadFamily() {
    this.getFamily(this.$route.params.id, FamilyEdit.getFamilytag).then(
      (resp) => {
        this.family = resp;
        this.icon = { url: this.family.iconUrl };
      },
      (err) => {}
    );
  }
  openFiles() {
    const file = (this.$refs.upload as any).openFileBrowser();
  }

  updatePayload() {
    let payload = new FormData();
    for (const key of [
      "name",
      "code",
      "descriptionIt",
      "descriptionEn",
      "generic",
    ]) {
      if (this.family[key] !== null && this.family[key] !== undefined) {
        payload.append(key, this.family[key]);
      }
    }
    if (this.newIcon) {
      payload.append("icon", this.newIcon.file);
    }

    return payload;
  }

  removeAttachment(attachment) {}

  onUpdate() {
    const payload = this.updatePayload();
    this.updateFamily(this.family.id, payload, FamilyEdit.updateFamilytag).then(
      (resp) => {
        showToast(`Family ${resp.name} updated successfully`);
        this.$router.push({ name: "family", params: { id: resp.id } });
      },
      (err) => {
        const message = err?.response?.data?.message || err.message;
        showToast(
          `An error occurred while creating the family "${this.family.name}". ${message}`,
          {
            type: "error",
          }
        );
      }
    );
  }
}
